module.exports = __webpack_public_path__ + "static/img/Ace of Cups.70715b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ace of Cups.jpg
// module id = 1256
// module chunks = 0